import React from 'react';

// components
import LinkButton from '@src/components/buttons/CTA';

export default function LinkBlocks(props) {
    const { data } = props;
    const items = data.linkItem;

    return (
        <div className="grid grid--2 grid--small-margin">
            {items.map((item, i) => (
                <div
                    // eslint-disable-next-line react/no-array-index-key
                    key={`item-${i}`}
                    style={{ padding: '2em', backgroundColor: 'white', color: 'black' }}>
                    <div
                        className="rich-text"
                        dangerouslySetInnerHTML={{ __html: item.richText }}
                    />
                    {item.buttonUrl ? (
                        <div className="relative mt-12" style={{ fontStyle: 'italic' }}>
                            <LinkButton large to={item.buttonUrl} copy={item.buttonCopy} />
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}
